import type { TLngLat } from 'App/Map/types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TIrrigationZoneEmitterId, TPropertyId } from 'stores/fieldAssetStore/helperTypes'

export const getPointLngLatsForIrrigationEmitterZoneId = ({
  propertyId,
  irrigationEmitterZoneId,
}: {
  propertyId: TPropertyId
  irrigationEmitterZoneId: TIrrigationZoneEmitterId
}): TLngLat[] => {
  const property = fieldAssetStore.getState()?.properties?.[propertyId]

  if (property) {
    const pointsForZone = Object.values(property.points || {}).filter((p) =>
      p.irrigationEmitterZoneIds?.includes(irrigationEmitterZoneId),
    )

    return pointsForZone.map((p) => p.lngLat)
  }

  return []
}
